import { FunctionComponent } from 'react';
import {
  ReplyType,
  Ticket,
  TimelineItem,
  TimelineItemType,
  TimelineReply,
} from '@wix/answers-api';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { TicketTimelineItem } from './TicketTimelineItem';
import { TicketOverYear } from './TicketOverYear';
import { DATA_HOOKS } from '../../dataHooks';
import { Reply } from './Reply';
import css from './index.module.scss';

type TicketContentProps = {
  ticket: Ticket;
  timelineItems: TimelineItem[];
  onReplyAdded: (timelineItem: TimelineItem) => void;
};

export const TicketContent: FunctionComponent<TicketContentProps> = ({
  ticket,
  timelineItems,
  onReplyAdded,
}: TicketContentProps) => {
  const { t } = useTranslation();
  const filteredTimelineItems = timelineItems.filter(
    (timelineItem) =>
      (timelineItem.timelineItemType === undefined ||
        timelineItem.timelineItemType === TimelineItemType.CHAT_MESSAGE ||
        (timelineItem.timelineItemType === TimelineItemType.REPLY &&
          // @ts-expect-error subTypeValue exist
          timelineItem.subTypeValue !== 120)) &&
      timelineItem.content
  );

  return (
    <Box className={css.wrapper} direction="vertical">
      <TicketOverYear ticket={ticket} />
      <Box className={css.ticketWrapper}>
        <Text
          size="tiny"
          className={css.ticketNumber}
          dataHook={DATA_HOOKS.TICKET_NUMBER}
        >
          {t('ticket.id')} {ticket.ticketNumber}
        </Text>
        <TicketTimelineItem
          user={ticket.user}
          subject={ticket.subject}
          content={ticket.content}
          creationDate={ticket.creationDate}
          isAgent={false}
        />
      </Box>
      <Box className={css.replies}>
        <Heading
          size="medium"
          className={css.repliesText}
          dataHook={DATA_HOOKS.TICKET_REPLIES_TITLE}
        >
          {t('ticket.replies')} <span>({filteredTimelineItems.length})</span>
        </Heading>
        <div className={css.repliesLine}></div>
      </Box>
      {filteredTimelineItems.map((timelineItem: TimelineItem) => (
        <TicketTimelineItem
          key={(timelineItem as TimelineReply).id}
          user={(timelineItem as TimelineReply).user}
          content={(timelineItem as TimelineReply).content}
          creationDate={(timelineItem as TimelineReply).creationDate}
          isAgent={(timelineItem as TimelineReply).type === ReplyType.AGENT}
          attachments={(timelineItem as TimelineReply).attachments}
        />
      ))}
      <Reply
        user={ticket.user}
        ticketId={ticket.id}
        onReplyAdded={onReplyAdded}
      />
    </Box>
  );
};
